import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'minutesRemain'
})
export class MinutesRemainPipe implements PipeTransform {

  transform(value: any): string {
    var sec_num = parseInt(value, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);

    return minutes > 9 ? `${minutes}` : `0${minutes}`;
  }

}
